export class ProductNames {
  public static SNF = "MatrixCare 360";
  public static SL = "Senior Living";
  public static LPC = "Life Plan Community";
  public static PP = "Payment Portal";
  public static CA = "CareAssist";
  public static PD = "Private Duty";
  public static AA = "Identity Management Access";
  public static MCMD = "MatrixCare Engage";
  public static TS = "Ambient Operating System";  //True Sense has been renamed to Ambient Operating System
  public static S4B = "Solutions for Business";
  public static RTO = "Retail Tracker Online";
  public static SIGMACARE = "SigmaCare";
}
